import type { CSSProperties } from 'react';

export type BrandSurface = 'dark' | 'light';

export interface StrikerBrandProps {
  /** Dark surface → light wordmark; light surface → dark wordmark. */
  surface?: BrandSurface;
  /** Prefer full logo lockup (mark + wordmark). */
  withWordmark?: boolean;
  className?: string;
  style?: CSSProperties;
  /** Accessible name for the home/brand link or image. */
  title?: string;
}

/** Transparent violet/mint mark (works on dark and light). */
const MARK_SRC = '/brand/mark.svg';

/**
 * Official StrikerPos lockup: brand mark + adaptive wordmark.
 * Use `surface="dark"` on shell/login; `surface="light"` on pale cards/public pages.
 */
export function StrikerBrand({
  surface = 'dark',
  withWordmark = true,
  className = '',
  style,
  title = 'StrikerPos',
}: StrikerBrandProps) {
  const surfaceClass = surface === 'light' ? 'sk-brand--on-light' : 'sk-brand--on-dark';
  return (
    <span className={`sk-brand ${surfaceClass} ${className}`.trim()} style={style} title={title}>
      <img className="sk-brand__mark" src={MARK_SRC} alt="" width={40} height={40} />
      {withWordmark ? <span className="sk-brand__wordmark">StrikerPos</span> : null}
      <span className="sk-sr-only">{title}</span>
    </span>
  );
}
